<template>
    <div class="printers">
        <component
            :is="isAllegra ? 'AllegraPrintersSettings' : 'AriaPrintersSettings'"
            v-if="loaded"
            :predefined-printers="predefinedPrinters"
            :server-print-config="serverPrintConfig"
        />
    </div>
</template>

<script>
import { loadData } from '@/views/shared/loadPageData';
import AriaPrintersSettings from '@/views/aria/PrintersSettings';
import AllegraPrintersSettings from '@/views/allegra/PrintersSettings';

export default {
    components: {
        AriaPrintersSettings,
        AllegraPrintersSettings
    },

    beforeRouteEnter: (to, from, next) => {
        loadData('/admin/load/printers').then(data => next(vm => vm.onDataLoaded(data)));
    },

    data() {
        return {
            loaded: false,
            predefinedPrinters: [],
            serverPrintConfig: null,
        };
    },

    methods: {
        onDataLoaded(data) {
            this.predefinedPrinters = data.printers;
            this.serverPrintConfig = data.printConfig;
            this.loaded = true;
        },
    }
};
</script>

<style lang="scss" scoped>
.printers {
    max-width: 600px;
}
</style>
